import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":""}},[_c(VRow,[_c(VCol,[_c('PendingDPD'),_c('PendingCTT'),_c('PendingDELNEXT')],1),_c(VCol,[_c('PendingREDUR')],1)],1),_c(VRow,[_c(VCol,[_c('PendingClient')],1),_c(VCol,[_c('NCStatistics')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }